import { render } from "./TestItem.vue?vue&type=template&id=594ced4c&scoped=true"
import script from "./TestItem.vue?vue&type=script&lang=js"
export * from "./TestItem.vue?vue&type=script&lang=js"

import "./TestItem.vue?vue&type=style&index=0&id=594ced4c&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594ced4c"]])

export default __exports__